import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from "./components/footer/footer.component";

@Component({
  selector: 'app-extranet',
  standalone: true,
  imports: [RouterOutlet, FooterComponent],
  templateUrl: './extranet.component.html',
  styleUrl: './extranet.component.scss'
})
export class ExtranetComponent {

}
